<template>
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    :class="newArticleDetailsDisplay ? 'mr-1' : 'mr-2'"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.27156 12.5982L1.26994 12.5992C0.933862 12.8149 0.5 12.576 0.5 12.18V1.82001C0.5 1.42405 0.933862 1.18511 1.26994 1.4008L1.27193 1.40207L9.40894 6.57016C9.40934 6.57042 9.40974 6.57068 9.41015 6.57094C9.72757 6.77688 9.71778 7.22555 9.41377 7.41678L9.41377 7.41677L9.41156 7.41818L1.27156 12.5982Z"
      stroke="white"
    />
  </svg>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),
  },
};
</script>
